import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeHtmlContent } from '../utils/html-sanitizer.util';

@Pipe({
    name: 'safeHtml',
    standalone: true
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined, anchorColor?: string): SafeHtml {
    const sanitized = sanitizeHtmlContent(value, { anchorColor });
    return this.sanitizer.bypassSecurityTrustHtml(sanitized);
  }
}
